var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-modal',{attrs:{"width":"600px","visible":_vm.visible,"confirm-loading":_vm.confirmLoading,"footer":null,"closable":true},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('RegisterForm',{ref:"registerform",on:{"ok":_vm.loginok,"clear":_vm.clear}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-523557bf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/Register.vue
// module id = null
// module chunks = 